module.exports = __webpack_public_path__ + "static/img/dmsLogo.2e283f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/dmsLogo.png
// module id = Wh8T
// module chunks = 2